import type { FilterComposable } from '@autobid/ui/composables/carsList/useFilter'
import { inject } from 'vue'

export function injectFilterComposable() {
  return inject('carsListFilterComposable') as () => ReturnType<FilterComposable>
}
